import { Expose } from "class-transformer";
import { IsEnum, IsString } from "class-validator";
import { SERVICE_TYPE_GROUP_ENUM } from "@/static/serviceTypeGroupEnum";

export class NewServiceTypeGroup {
  @Expose()
  @IsString()
  name!: string;
  @Expose()
  @IsString()
  displayedName!: string;
  @Expose()
  @IsEnum(SERVICE_TYPE_GROUP_ENUM)
  type!: SERVICE_TYPE_GROUP_ENUM;

  constructor() {
    (this.name = ""), (this.displayedName = ""), (this.type = SERVICE_TYPE_GROUP_ENUM.Booking);
  }
}
